import React, { useState, useEffect } from 'react';

interface DebouncedInputProps extends React.InputHTMLAttributes<HTMLInputElement> {
    value: string;
    onDebouncedChange: (value: string) => void;
    delay?: number;
}

export const DebouncedInput: React.FC<DebouncedInputProps> = ({
                                                           value,
                                                           onDebouncedChange,
                                                           delay = 300,
                                                           ...rest
                                                       }) => {
    const [localValue, setLocalValue] = useState(value);

    useEffect(() => {
        setLocalValue(value);
    }, [value]);

    useEffect(() => {
        const handler = setTimeout(() => {
            onDebouncedChange(localValue);
        }, delay);

        return () => {
            clearTimeout(handler);
        };
    }, [localValue, onDebouncedChange, delay]);

    return (
        <input
            {...rest}
            value={localValue}
            onChange={(e) => setLocalValue(e.target.value)}
        />
    );
};